import styled from 'styled-components'

export const TitleFooter = styled.div`
  color: var(--shape);
  font-size: 0.875rem;
  font-weight: 700;
  word-wrap: break-word;
`
